(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"]) return;
  try {
     
document.addEventListener('DOMContentLoaded', function() {
    var announcementBar = document.querySelector('.custom-announcement-bar');
    var announcementContent = announcementBar.querySelector('.announcement-content'); // Select the .announcement-content div
    var announcementImage = announcementBar.querySelector('.announcement-image');

    // Set the initial background image in JavaScript
    announcementContent.querySelector('.custom-expand-button').style.background = 'url("https://cdn.shopify.com/s/files/1/0068/4251/5544/files/Arrow_Down_White.svg?v=1699631803") no-repeat center center';
    announcementContent.querySelector('.custom-expand-button').style.backgroundSize = 'cover';
    
    announcementContent.addEventListener('click', function() {
        var expandButton = this.querySelector('.custom-expand-button'); // Select the .custom-expand-button inside this .announcement-content
        if (announcementImage.style.maxHeight) {
            announcementImage.style.maxHeight = null;
            expandButton.style.background = 'url("https://cdn.shopify.com/s/files/1/0068/4251/5544/files/Arrow_Down_White.svg?v=1699631803") no-repeat center center';
            expandButton.style.backgroundSize = 'cover';
        } else {
            announcementImage.style.maxHeight = announcementImage.scrollHeight + 'px';
            expandButton.style.background = 'url("https://cdn.shopify.com/s/files/1/0068/4251/5544/files/Arrow_Up_White.svg?v=1699631689") no-repeat center center';
            expandButton.style.backgroundSize = 'cover';
        }
    }); 
});

  } catch(e) { console.error(e); }
})();
})();
